import React from "react";
import { motion } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

// Section scroll reveal: subtle Y translation + fade.
export default function Reveal({ children, delay = 0, y = 40, className = "", once = true, duration = 0.9 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-10% 0px" }}
      transition={{ duration, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
}
